/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Api
 * BoredFan API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminOverview,
  AdminPuzzle,
  ApiMessage,
  Game,
  GameDetail,
  GenerateRequest,
  GenerateSummary,
  GetLeaderboardParams,
  GetMyStandingParams,
  GuessInput,
  GuessResult,
  HealthStatus,
  HomeSummary,
  IngestRequest,
  IngestSummary,
  Leaderboard,
  ListAdminPuzzlesParams,
  ListGamesParams,
  PlayCompletion,
  PlayResult,
  ProfileUpdate,
  PublicProfile,
  Puzzle,
  PuzzleReview,
  SportCategory,
  Standing,
  ToggleState,
  UserProfile,
  UserStats
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Health check
 */
export const healthCheck = async ( options?: Parameters<typeof customFetch>[1]): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMeUrl = () => {




  return `/api/me`
}

/**
 * @summary Get or auto-provision the current user's profile
 */
export const getMe = async ( options?: Parameters<typeof customFetch>[1]): Promise<UserProfile> => {

  return customFetch<UserProfile>(getGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMeQueryKey = () => {
    return [
    `/api/me`
    ] as const;
    }


export const getGetMeQueryOptions = <TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ApiMessage>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({ signal }) => getMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>
export type GetMeQueryError = ErrorType<ApiMessage>


/**
 * @summary Get or auto-provision the current user's profile
 */

export function useGetMe<TData = Awaited<ReturnType<typeof getMe>>, TError = ErrorType<ApiMessage>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateMeUrl = () => {




  return `/api/me`
}

/**
 * @summary Update username or avatar
 */
export const updateMe = async (profileUpdate: ProfileUpdate, options?: Parameters<typeof customFetch>[1]): Promise<UserProfile> => {

  return customFetch<UserProfile>(getUpdateMeUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(profileUpdate)
  }
);}





export const getUpdateMeMutationOptions = <TError = ErrorType<ApiMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMe>>, TError,{data: BodyType<ProfileUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMe>>, TError,{data: BodyType<ProfileUpdate>}, TContext> => {

const mutationKey = ['updateMe'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMe>>, {data: BodyType<ProfileUpdate>}> = (props) => {
          const {data} = props ?? {};

          return  updateMe(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMeMutationResult = NonNullable<Awaited<ReturnType<typeof updateMe>>>
    export type UpdateMeMutationBody = BodyType<ProfileUpdate>
    export type UpdateMeMutationError = ErrorType<ApiMessage>

    /**
 * @summary Update username or avatar
 */
export const useUpdateMe = <TError = ErrorType<ApiMessage>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMe>>, TError,{data: BodyType<ProfileUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMe>>,
        TError,
        {data: BodyType<ProfileUpdate>},
        TContext
      > => {
      return useMutation(getUpdateMeMutationOptions(options));
    }

export const getGetMyStandingUrl = (params?: GetMyStandingParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/me/standing?${stringifiedParams}` : `/api/me/standing`
}

/**
 * @summary The signed-in player's all-time rank (site-wide and optionally per game)
 */
export const getMyStanding = async (params?: GetMyStandingParams, options?: Parameters<typeof customFetch>[1]): Promise<Standing> => {

  return customFetch<Standing>(getGetMyStandingUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyStandingQueryKey = (params?: GetMyStandingParams,) => {
    return [
    `/api/me/standing`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMyStandingQueryOptions = <TData = Awaited<ReturnType<typeof getMyStanding>>, TError = ErrorType<ApiMessage>>(params?: GetMyStandingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyStanding>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyStandingQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyStanding>>> = ({ signal }) => getMyStanding(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyStanding>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyStandingQueryResult = NonNullable<Awaited<ReturnType<typeof getMyStanding>>>
export type GetMyStandingQueryError = ErrorType<ApiMessage>


/**
 * @summary The signed-in player's all-time rank (site-wide and optionally per game)
 */

export function useGetMyStanding<TData = Awaited<ReturnType<typeof getMyStanding>>, TError = ErrorType<ApiMessage>>(
 params?: GetMyStandingParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyStanding>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyStandingQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMyStatsUrl = () => {




  return `/api/me/stats`
}

/**
 * @summary Current user's play statistics
 */
export const getMyStats = async ( options?: Parameters<typeof customFetch>[1]): Promise<UserStats> => {

  return customFetch<UserStats>(getGetMyStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyStatsQueryKey = () => {
    return [
    `/api/me/stats`
    ] as const;
    }


export const getGetMyStatsQueryOptions = <TData = Awaited<ReturnType<typeof getMyStats>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyStats>>> = ({ signal }) => getMyStats({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyStats>>>
export type GetMyStatsQueryError = ErrorType<unknown>


/**
 * @summary Current user's play statistics
 */

export function useGetMyStats<TData = Awaited<ReturnType<typeof getMyStats>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyStatsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetMyFavoritesUrl = () => {




  return `/api/me/favorites`
}

/**
 * @summary Games the current user favorited
 */
export const getMyFavorites = async ( options?: Parameters<typeof customFetch>[1]): Promise<Game[]> => {

  return customFetch<Game[]>(getGetMyFavoritesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyFavoritesQueryKey = () => {
    return [
    `/api/me/favorites`
    ] as const;
    }


export const getGetMyFavoritesQueryOptions = <TData = Awaited<ReturnType<typeof getMyFavorites>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyFavorites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyFavoritesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyFavorites>>> = ({ signal }) => getMyFavorites({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyFavorites>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyFavoritesQueryResult = NonNullable<Awaited<ReturnType<typeof getMyFavorites>>>
export type GetMyFavoritesQueryError = ErrorType<unknown>


/**
 * @summary Games the current user favorited
 */

export function useGetMyFavorites<TData = Awaited<ReturnType<typeof getMyFavorites>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyFavorites>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyFavoritesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetUserProfileUrl = (username: string,) => {




  return `/api/users/${username}`
}

/**
 * @summary Public profile by username
 */
export const getUserProfile = async (username: string, options?: Parameters<typeof customFetch>[1]): Promise<PublicProfile> => {

  return customFetch<PublicProfile>(getGetUserProfileUrl(username),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUserProfileQueryKey = (username: string,) => {
    return [
    `/api/users/${username}`
    ] as const;
    }


export const getGetUserProfileQueryOptions = <TData = Awaited<ReturnType<typeof getUserProfile>>, TError = ErrorType<ApiMessage>>(username: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserProfileQueryKey(username);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserProfile>>> = ({ signal }) => getUserProfile(username, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: username !== null && username !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getUserProfile>>>
export type GetUserProfileQueryError = ErrorType<ApiMessage>


/**
 * @summary Public profile by username
 */

export function useGetUserProfile<TData = Awaited<ReturnType<typeof getUserProfile>>, TError = ErrorType<ApiMessage>>(
 username: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUserProfileQueryOptions(username,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListSportsUrl = () => {




  return `/api/sports`
}

/**
 * @summary Sports categories with game counts
 */
export const listSports = async ( options?: Parameters<typeof customFetch>[1]): Promise<SportCategory[]> => {

  return customFetch<SportCategory[]>(getListSportsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSportsQueryKey = () => {
    return [
    `/api/sports`
    ] as const;
    }


export const getListSportsQueryOptions = <TData = Awaited<ReturnType<typeof listSports>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSportsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSports>>> = ({ signal }) => listSports({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSports>>, TError, TData> & { queryKey: QueryKey }
}

export type ListSportsQueryResult = NonNullable<Awaited<ReturnType<typeof listSports>>>
export type ListSportsQueryError = ErrorType<unknown>


/**
 * @summary Sports categories with game counts
 */

export function useListSports<TData = Awaited<ReturnType<typeof listSports>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listSports>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListSportsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListGamesUrl = (params?: ListGamesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/games?${stringifiedParams}` : `/api/games`
}

/**
 * @summary Browse the game catalog
 */
export const listGames = async (params?: ListGamesParams, options?: Parameters<typeof customFetch>[1]): Promise<Game[]> => {

  return customFetch<Game[]>(getListGamesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGamesQueryKey = (params?: ListGamesParams,) => {
    return [
    `/api/games`, ...(params ? [params] : [])
    ] as const;
    }


export const getListGamesQueryOptions = <TData = Awaited<ReturnType<typeof listGames>>, TError = ErrorType<unknown>>(params?: ListGamesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGames>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGamesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGames>>> = ({ signal }) => listGames(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGames>>, TError, TData> & { queryKey: QueryKey }
}

export type ListGamesQueryResult = NonNullable<Awaited<ReturnType<typeof listGames>>>
export type ListGamesQueryError = ErrorType<unknown>


/**
 * @summary Browse the game catalog
 */

export function useListGames<TData = Awaited<ReturnType<typeof listGames>>, TError = ErrorType<unknown>>(
 params?: ListGamesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGames>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListGamesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetGameUrl = (slug: string,) => {




  return `/api/games/${slug}`
}

/**
 * @summary Game detail
 */
export const getGame = async (slug: string, options?: Parameters<typeof customFetch>[1]): Promise<GameDetail> => {

  return customFetch<GameDetail>(getGetGameUrl(slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGameQueryKey = (slug: string,) => {
    return [
    `/api/games/${slug}`
    ] as const;
    }


export const getGetGameQueryOptions = <TData = Awaited<ReturnType<typeof getGame>>, TError = ErrorType<ApiMessage>>(slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGame>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGameQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGame>>> = ({ signal }) => getGame(slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGame>>, TError, TData> & { queryKey: QueryKey }
}

export type GetGameQueryResult = NonNullable<Awaited<ReturnType<typeof getGame>>>
export type GetGameQueryError = ErrorType<ApiMessage>


/**
 * @summary Game detail
 */

export function useGetGame<TData = Awaited<ReturnType<typeof getGame>>, TError = ErrorType<ApiMessage>>(
 slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getGame>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetGameQueryOptions(slug,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getToggleGameLikeUrl = (slug: string,) => {




  return `/api/games/${slug}/like`
}

/**
 * @summary Toggle like on a game
 */
export const toggleGameLike = async (slug: string, options?: Parameters<typeof customFetch>[1]): Promise<ToggleState> => {

  return customFetch<ToggleState>(getToggleGameLikeUrl(slug),
  {
    ...options,
    method: 'POST'


  }
);}





export const getToggleGameLikeMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleGameLike>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleGameLike>>, TError,{slug: string}, TContext> => {

const mutationKey = ['toggleGameLike'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleGameLike>>, {slug: string}> = (props) => {
          const {slug} = props ?? {};

          return  toggleGameLike(slug,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ToggleGameLikeMutationResult = NonNullable<Awaited<ReturnType<typeof toggleGameLike>>>

    export type ToggleGameLikeMutationError = ErrorType<unknown>

    /**
 * @summary Toggle like on a game
 */
export const useToggleGameLike = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleGameLike>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof toggleGameLike>>,
        TError,
        {slug: string},
        TContext
      > => {
      return useMutation(getToggleGameLikeMutationOptions(options));
    }

export const getToggleGameFavoriteUrl = (slug: string,) => {




  return `/api/games/${slug}/favorite`
}

/**
 * @summary Toggle favorite on a game
 */
export const toggleGameFavorite = async (slug: string, options?: Parameters<typeof customFetch>[1]): Promise<ToggleState> => {

  return customFetch<ToggleState>(getToggleGameFavoriteUrl(slug),
  {
    ...options,
    method: 'POST'


  }
);}





export const getToggleGameFavoriteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleGameFavorite>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof toggleGameFavorite>>, TError,{slug: string}, TContext> => {

const mutationKey = ['toggleGameFavorite'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleGameFavorite>>, {slug: string}> = (props) => {
          const {slug} = props ?? {};

          return  toggleGameFavorite(slug,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ToggleGameFavoriteMutationResult = NonNullable<Awaited<ReturnType<typeof toggleGameFavorite>>>

    export type ToggleGameFavoriteMutationError = ErrorType<unknown>

    /**
 * @summary Toggle favorite on a game
 */
export const useToggleGameFavorite = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleGameFavorite>>, TError,{slug: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof toggleGameFavorite>>,
        TError,
        {slug: string},
        TContext
      > => {
      return useMutation(getToggleGameFavoriteMutationOptions(options));
    }

export const getGetDailyPuzzleUrl = (slug: string,) => {




  return `/api/games/${slug}/daily`
}

/**
 * @summary Today's daily puzzle for a game (answers omitted)
 */
export const getDailyPuzzle = async (slug: string, options?: Parameters<typeof customFetch>[1]): Promise<Puzzle> => {

  return customFetch<Puzzle>(getGetDailyPuzzleUrl(slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDailyPuzzleQueryKey = (slug: string,) => {
    return [
    `/api/games/${slug}/daily`
    ] as const;
    }


export const getGetDailyPuzzleQueryOptions = <TData = Awaited<ReturnType<typeof getDailyPuzzle>>, TError = ErrorType<ApiMessage>>(slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDailyPuzzle>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDailyPuzzleQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDailyPuzzle>>> = ({ signal }) => getDailyPuzzle(slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDailyPuzzle>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDailyPuzzleQueryResult = NonNullable<Awaited<ReturnType<typeof getDailyPuzzle>>>
export type GetDailyPuzzleQueryError = ErrorType<ApiMessage>


/**
 * @summary Today's daily puzzle for a game (answers omitted)
 */

export function useGetDailyPuzzle<TData = Awaited<ReturnType<typeof getDailyPuzzle>>, TError = ErrorType<ApiMessage>>(
 slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDailyPuzzle>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDailyPuzzleQueryOptions(slug,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetUnlimitedPuzzleUrl = (slug: string,) => {




  return `/api/games/${slug}/unlimited`
}

/**
 * @summary A random archived puzzle for unlimited mode
 */
export const getUnlimitedPuzzle = async (slug: string, options?: Parameters<typeof customFetch>[1]): Promise<Puzzle> => {

  return customFetch<Puzzle>(getGetUnlimitedPuzzleUrl(slug),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUnlimitedPuzzleQueryKey = (slug: string,) => {
    return [
    `/api/games/${slug}/unlimited`
    ] as const;
    }


export const getGetUnlimitedPuzzleQueryOptions = <TData = Awaited<ReturnType<typeof getUnlimitedPuzzle>>, TError = ErrorType<ApiMessage>>(slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUnlimitedPuzzle>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUnlimitedPuzzleQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnlimitedPuzzle>>> = ({ signal }) => getUnlimitedPuzzle(slug, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUnlimitedPuzzle>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUnlimitedPuzzleQueryResult = NonNullable<Awaited<ReturnType<typeof getUnlimitedPuzzle>>>
export type GetUnlimitedPuzzleQueryError = ErrorType<ApiMessage>


/**
 * @summary A random archived puzzle for unlimited mode
 */

export function useGetUnlimitedPuzzle<TData = Awaited<ReturnType<typeof getUnlimitedPuzzle>>, TError = ErrorType<ApiMessage>>(
 slug: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUnlimitedPuzzle>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetUnlimitedPuzzleQueryOptions(slug,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubmitGuessUrl = (puzzleId: number,) => {




  return `/api/puzzles/${puzzleId}/guess`
}

/**
 * @summary Submit a guess for one round; server judges it
 */
export const submitGuess = async (puzzleId: number,
    guessInput: GuessInput, options?: Parameters<typeof customFetch>[1]): Promise<GuessResult> => {

  return customFetch<GuessResult>(getSubmitGuessUrl(puzzleId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(guessInput)
  }
);}





export const getSubmitGuessMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitGuess>>, TError,{puzzleId: number;data: BodyType<GuessInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitGuess>>, TError,{puzzleId: number;data: BodyType<GuessInput>}, TContext> => {

const mutationKey = ['submitGuess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitGuess>>, {puzzleId: number;data: BodyType<GuessInput>}> = (props) => {
          const {puzzleId,data} = props ?? {};

          return  submitGuess(puzzleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitGuessMutationResult = NonNullable<Awaited<ReturnType<typeof submitGuess>>>
    export type SubmitGuessMutationBody = BodyType<GuessInput>
    export type SubmitGuessMutationError = ErrorType<unknown>

    /**
 * @summary Submit a guess for one round; server judges it
 */
export const useSubmitGuess = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitGuess>>, TError,{puzzleId: number;data: BodyType<GuessInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitGuess>>,
        TError,
        {puzzleId: number;data: BodyType<GuessInput>},
        TContext
      > => {
      return useMutation(getSubmitGuessMutationOptions(options));
    }

export const getCompletePuzzleUrl = (puzzleId: number,) => {




  return `/api/puzzles/${puzzleId}/complete`
}

/**
 * @summary Record a finished play, award XP and streaks
 */
export const completePuzzle = async (puzzleId: number,
    playCompletion: PlayCompletion, options?: Parameters<typeof customFetch>[1]): Promise<PlayResult> => {

  return customFetch<PlayResult>(getCompletePuzzleUrl(puzzleId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(playCompletion)
  }
);}





export const getCompletePuzzleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completePuzzle>>, TError,{puzzleId: number;data: BodyType<PlayCompletion>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof completePuzzle>>, TError,{puzzleId: number;data: BodyType<PlayCompletion>}, TContext> => {

const mutationKey = ['completePuzzle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completePuzzle>>, {puzzleId: number;data: BodyType<PlayCompletion>}> = (props) => {
          const {puzzleId,data} = props ?? {};

          return  completePuzzle(puzzleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompletePuzzleMutationResult = NonNullable<Awaited<ReturnType<typeof completePuzzle>>>
    export type CompletePuzzleMutationBody = BodyType<PlayCompletion>
    export type CompletePuzzleMutationError = ErrorType<unknown>

    /**
 * @summary Record a finished play, award XP and streaks
 */
export const useCompletePuzzle = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completePuzzle>>, TError,{puzzleId: number;data: BodyType<PlayCompletion>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof completePuzzle>>,
        TError,
        {puzzleId: number;data: BodyType<PlayCompletion>},
        TContext
      > => {
      return useMutation(getCompletePuzzleMutationOptions(options));
    }

export const getGetLeaderboardUrl = (params?: GetLeaderboardParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/leaderboards?${stringifiedParams}` : `/api/leaderboards`
}

/**
 * @summary Leaderboard entries
 */
export const getLeaderboard = async (params?: GetLeaderboardParams, options?: Parameters<typeof customFetch>[1]): Promise<Leaderboard> => {

  return customFetch<Leaderboard>(getGetLeaderboardUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLeaderboardQueryKey = (params?: GetLeaderboardParams,) => {
    return [
    `/api/leaderboards`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetLeaderboardQueryOptions = <TData = Awaited<ReturnType<typeof getLeaderboard>>, TError = ErrorType<unknown>>(params?: GetLeaderboardParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLeaderboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLeaderboardQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLeaderboard>>> = ({ signal }) => getLeaderboard(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLeaderboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLeaderboardQueryResult = NonNullable<Awaited<ReturnType<typeof getLeaderboard>>>
export type GetLeaderboardQueryError = ErrorType<unknown>


/**
 * @summary Leaderboard entries
 */

export function useGetLeaderboard<TData = Awaited<ReturnType<typeof getLeaderboard>>, TError = ErrorType<unknown>>(
 params?: GetLeaderboardParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLeaderboard>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLeaderboardQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetHomeSummaryUrl = () => {




  return `/api/home`
}

/**
 * @summary Homepage summary (daily games, trending, new, featured, top streaks)
 */
export const getHomeSummary = async ( options?: Parameters<typeof customFetch>[1]): Promise<HomeSummary> => {

  return customFetch<HomeSummary>(getGetHomeSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHomeSummaryQueryKey = () => {
    return [
    `/api/home`
    ] as const;
    }


export const getGetHomeSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getHomeSummary>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHomeSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHomeSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHomeSummary>>> = ({ signal }) => getHomeSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHomeSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetHomeSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getHomeSummary>>>
export type GetHomeSummaryQueryError = ErrorType<unknown>


/**
 * @summary Homepage summary (daily games, trending, new, featured, top streaks)
 */

export function useGetHomeSummary<TData = Awaited<ReturnType<typeof getHomeSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getHomeSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetHomeSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAdminOverviewUrl = () => {




  return `/api/admin/overview`
}

/**
 * @summary Admin content overview (counts of teams, players, puzzles by status)
 */
export const getAdminOverview = async ( options?: Parameters<typeof customFetch>[1]): Promise<AdminOverview> => {

  return customFetch<AdminOverview>(getGetAdminOverviewUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminOverviewQueryKey = () => {
    return [
    `/api/admin/overview`
    ] as const;
    }


export const getGetAdminOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getAdminOverview>>, TError = ErrorType<ApiMessage>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminOverview>>> = ({ signal }) => getAdminOverview({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAdminOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminOverview>>>
export type GetAdminOverviewQueryError = ErrorType<ApiMessage>


/**
 * @summary Admin content overview (counts of teams, players, puzzles by status)
 */

export function useGetAdminOverview<TData = Awaited<ReturnType<typeof getAdminOverview>>, TError = ErrorType<ApiMessage>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAdminOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAdminOverviewQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getRunIngestionUrl = () => {




  return `/api/admin/ingest`
}

/**
 * @summary Ingest teams and players for a league from the sports data source
 */
export const runIngestion = async (ingestRequest: IngestRequest, options?: Parameters<typeof customFetch>[1]): Promise<IngestSummary> => {

  return customFetch<IngestSummary>(getRunIngestionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(ingestRequest)
  }
);}





export const getRunIngestionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runIngestion>>, TError,{data: BodyType<IngestRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runIngestion>>, TError,{data: BodyType<IngestRequest>}, TContext> => {

const mutationKey = ['runIngestion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runIngestion>>, {data: BodyType<IngestRequest>}> = (props) => {
          const {data} = props ?? {};

          return  runIngestion(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunIngestionMutationResult = NonNullable<Awaited<ReturnType<typeof runIngestion>>>
    export type RunIngestionMutationBody = BodyType<IngestRequest>
    export type RunIngestionMutationError = ErrorType<unknown>

    /**
 * @summary Ingest teams and players for a league from the sports data source
 */
export const useRunIngestion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runIngestion>>, TError,{data: BodyType<IngestRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runIngestion>>,
        TError,
        {data: BodyType<IngestRequest>},
        TContext
      > => {
      return useMutation(getRunIngestionMutationOptions(options));
    }

export const getGeneratePuzzlesUrl = () => {




  return `/api/admin/generate`
}

/**
 * @summary Auto-generate puzzles for a game from ingested data
 */
export const generatePuzzles = async (generateRequest: GenerateRequest, options?: Parameters<typeof customFetch>[1]): Promise<GenerateSummary> => {

  return customFetch<GenerateSummary>(getGeneratePuzzlesUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(generateRequest)
  }
);}





export const getGeneratePuzzlesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generatePuzzles>>, TError,{data: BodyType<GenerateRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generatePuzzles>>, TError,{data: BodyType<GenerateRequest>}, TContext> => {

const mutationKey = ['generatePuzzles'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generatePuzzles>>, {data: BodyType<GenerateRequest>}> = (props) => {
          const {data} = props ?? {};

          return  generatePuzzles(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GeneratePuzzlesMutationResult = NonNullable<Awaited<ReturnType<typeof generatePuzzles>>>
    export type GeneratePuzzlesMutationBody = BodyType<GenerateRequest>
    export type GeneratePuzzlesMutationError = ErrorType<unknown>

    /**
 * @summary Auto-generate puzzles for a game from ingested data
 */
export const useGeneratePuzzles = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generatePuzzles>>, TError,{data: BodyType<GenerateRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof generatePuzzles>>,
        TError,
        {data: BodyType<GenerateRequest>},
        TContext
      > => {
      return useMutation(getGeneratePuzzlesMutationOptions(options));
    }

export const getListAdminPuzzlesUrl = (params?: ListAdminPuzzlesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/puzzles?${stringifiedParams}` : `/api/admin/puzzles`
}

/**
 * @summary List generated puzzles for review
 */
export const listAdminPuzzles = async (params?: ListAdminPuzzlesParams, options?: Parameters<typeof customFetch>[1]): Promise<AdminPuzzle[]> => {

  return customFetch<AdminPuzzle[]>(getListAdminPuzzlesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminPuzzlesQueryKey = (params?: ListAdminPuzzlesParams,) => {
    return [
    `/api/admin/puzzles`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdminPuzzlesQueryOptions = <TData = Awaited<ReturnType<typeof listAdminPuzzles>>, TError = ErrorType<unknown>>(params?: ListAdminPuzzlesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminPuzzles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminPuzzlesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminPuzzles>>> = ({ signal }) => listAdminPuzzles(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminPuzzles>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAdminPuzzlesQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminPuzzles>>>
export type ListAdminPuzzlesQueryError = ErrorType<unknown>


/**
 * @summary List generated puzzles for review
 */

export function useListAdminPuzzles<TData = Awaited<ReturnType<typeof listAdminPuzzles>>, TError = ErrorType<unknown>>(
 params?: ListAdminPuzzlesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAdminPuzzles>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAdminPuzzlesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getReviewPuzzleUrl = (puzzleId: number,) => {




  return `/api/admin/puzzles/${puzzleId}/review`
}

/**
 * @summary Approve or reject a generated puzzle, optionally scheduling it as a daily
 */
export const reviewPuzzle = async (puzzleId: number,
    puzzleReview: PuzzleReview, options?: Parameters<typeof customFetch>[1]): Promise<AdminPuzzle> => {

  return customFetch<AdminPuzzle>(getReviewPuzzleUrl(puzzleId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(puzzleReview)
  }
);}





export const getReviewPuzzleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewPuzzle>>, TError,{puzzleId: number;data: BodyType<PuzzleReview>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reviewPuzzle>>, TError,{puzzleId: number;data: BodyType<PuzzleReview>}, TContext> => {

const mutationKey = ['reviewPuzzle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviewPuzzle>>, {puzzleId: number;data: BodyType<PuzzleReview>}> = (props) => {
          const {puzzleId,data} = props ?? {};

          return  reviewPuzzle(puzzleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviewPuzzleMutationResult = NonNullable<Awaited<ReturnType<typeof reviewPuzzle>>>
    export type ReviewPuzzleMutationBody = BodyType<PuzzleReview>
    export type ReviewPuzzleMutationError = ErrorType<unknown>

    /**
 * @summary Approve or reject a generated puzzle, optionally scheduling it as a daily
 */
export const useReviewPuzzle = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviewPuzzle>>, TError,{puzzleId: number;data: BodyType<PuzzleReview>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reviewPuzzle>>,
        TError,
        {puzzleId: number;data: BodyType<PuzzleReview>},
        TContext
      > => {
      return useMutation(getReviewPuzzleMutationOptions(options));
    }

